import { canStartOnStep } from '@funnel/steps/can-start-on';
import { employmentTypeStep } from '@funnel/steps/employment-type';
import { jobPositionQualificationStep } from '@funnel/steps/job-position-qualification';
import { personalDataStep } from '@funnel/steps/personal-data';
import { yearsOfExperienceStep } from '@funnel/steps/years-of-experience';

import { qualificationRecognitionStep } from '../steps/qualification-recognition';

/**
 * Holds the order of questions for the multiposting funnel.
 */
export const multipostingQuestions = [
  canStartOnStep,
  jobPositionQualificationStep,
  qualificationRecognitionStep(),
  yearsOfExperienceStep({ isMultiposting: true }),
  employmentTypeStep,
  personalDataStep,
] as const;
